// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__M0bNj","colCheckbox":"styles_colCheckbox__2n2Lk"};